import React from 'react';
import PropTypes from 'prop-types';
import backButtonArrow from '../../images/Autocode/backButtonArrow.svg';

const AutocodeBackButton = props => {
  const { title, toggleAutocode } = props;
  return (
    <button
      type="button"
      className="autocode-backbtn"
      onClick={() => toggleAutocode()}
      data-test="autocodebackBtn"
    >
      {title}
      <img className="autocode-backimage" src={backButtonArrow} alt="arrow" />
    </button>

  );
};

AutocodeBackButton.propTypes = {
  title: PropTypes.string.isRequired,
  toggleAutocode: PropTypes.func.isRequired,
};

export default AutocodeBackButton;
